import axiosClient from './axiosClient';

const API_URL = "/contact";

export interface ContactData {
    clientName: string;
    clientPhone: string;
    message?: string;
}

export const sendContact = async (data: ContactData) => {
    const response = await axiosClient.post(API_URL, data);
    return response.data;
};